import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useOrdersStore = create(
  persist(
    (set, get) => ({
      orders: [],
      
      createOrder: (orderData) => {
        const order = {
          id: `ord_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
          createdAt: new Date().toISOString(),
          status: 'pending',
          ...orderData
        }
        
        set((state) => ({
          orders: [order, ...state.orders]
        }))
        
        return order
      },
      
      getOrderById: (orderId) => {
        return get().orders.find(order => order.id === orderId) || null
      },
      
      updateOrderStatus: (orderId, status) => {
        set((state) => ({
          orders: state.orders.map(order =>
            order.id === orderId ? { ...order, status } : order
          )
        }))
      },
      
      getOrdersByUser: (userId) => {
        return get().orders.filter(order => order.userId === userId)
      }
    }),
    {
      name: 'orders-storage',
    }
  )
)